import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Use localStorage
import authReducer from './authSlice';
import itemsReducer  from './itemSlice';
import invoiceReducer from './invoiceSlice';
import indentReducer from './indentSlice';
import peindentReducer from './peindentSlice';
import peitemsReducer from './peitemsSlice';
import dashboardReducer from './dashboardSlice';

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, authReducer);

const store = configureStore({
  reducer: {
    auth: persistedReducer,
    items: itemsReducer,
    invoice: invoiceReducer,
    indent: indentReducer,
    peindent: peindentReducer,
    peitem: peitemsReducer,
    dashboard: dashboardReducer,
  },
});

export const persistor = persistStore(store);
export default store;
